export const kShopFirestoreKey = "shop-products";
export const kShopOrdersFirestoreKey = "shop-orders";
export const kDoctorsFirestoreKey = "doctors";
export const kDriversFirestoreKey = "drivers";
export const kPharmaciesFirestoreKey = "pharmacies";
export const kPharmacyMedicinesFirestoreKey = "pharmacy-medicines";
export const kTreatments = "treatments";
export const kMedicineOrders  = "medicineOrders";